import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DataSourceCard.css';

interface DataSourceCardProps {
    logo: string;
    name: string;
    url: string;
}

const DataSourceCard: React.FC<DataSourceCardProps> = ({ logo, name, url }) => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(url);
    };

    return (
        <div className="data-source-card" onClick={handleClick}>
            <img className="data-source-logo" src={logo} alt={`${name} logo`} />
            <div className="data-source-text">
                <h3>{name}</h3>
            </div>
        </div>
    );
}

export default DataSourceCard;
